import {
  fetchAccounts,
  createAccount,
  updateAccount,
  deleteAccount,
} from "@/api/accounts";
import { cloneDeep } from "lodash";

const getDefaultState = () => ({
  accounts: [],
});

export const accounts = {
  state: getDefaultState(),
  getters: {
    allAccounts: (state) => cloneDeep(state.accounts).reverse(),
    totalBalance: (state) =>
      state.accounts.reduce(
        (total, account) => total + account.balanceInBaseCurrency,
        0
      ),
  },
  mutations: {
    SET_ACCOUNTS(state, accounts) {
      state.accounts = accounts;
    },
    CREATE_ACCOUNT(state, account) {
      state.accounts.push(account);
    },
    UPDATE_ACCOUNT(state, account) {
      const index = state.accounts.findIndex((acc) => acc.id === account.id);
      if (index != -1) {
        state.accounts.splice(index, 1, account);
      }
    },
    DELETE_ACCOUNT(state, account) {
      const index = state.accounts.findIndex((acc) => acc.id === account.id);
      if (index != -1) {
        state.accounts.splice(index, 1);
      }
    },
    RESET_ACCOUNTS(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async fetchAccounts({ commit }) {
      try {
        const { data } = await fetchAccounts();
        commit("SET_ACCOUNTS", data);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async createAccount({ commit }, payload) {
      try {
        const { data } = await createAccount(payload);
        commit("CREATE_ACCOUNT", data);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async updateAccount({ commit }, { id, ...payload }) {
      try {
        const { data } = await updateAccount(id, payload);
        commit("UPDATE_ACCOUNT", data);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async deleteAccount({ commit }, id) {
      try {
        const { data } = await deleteAccount(id);
        commit("DELETE_ACCOUNT", { id, ...data });
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
